var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"we-panel",class:_vm.getClass},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.itemLength),function(i){return _c('div',{key:i},[(i>1)?_c('div',{staticClass:"we-panel-dash",style:(_vm.getDashStyle(i)),on:{"mousedown":function($event){$event.stopPropagation();return _vm.handleMouseDown(i, $event)}}}):_vm._e()])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }